import { Injectable } from "@angular/core";
import { GoogleLoginOptions, GoogleLoginResponseOnline, SocialLogin } from '@capgo/capacitor-social-login';

export interface GoogleUserProfile {
    email: string | null;
    familyName: string | null;
    givenName: string | null;
    id: string | null;
    name: string | null;
    imageUrl: string | null;
};

@Injectable({
    providedIn: "root"
})
export class GoogleAuthService {
    private static readonly GoogleLoginOptions: GoogleLoginOptions = {
                scopes: ['email', 'profile', 'photoslibrary.readonly'],
                forceRefreshToken: true // if you need refresh token
            };
    public async initialize() {
        await SocialLogin.initialize({
            google: {
                webClientId: 'WEB_CLIENT_ID.apps.googleusercontent.com', // Use Web Client ID for all platforms
                iOSClientId: 'IOS_CLIENT_ID', // for iOS
                mode: 'offline' // replaces grantOfflineAccess
            }
        });
    }

    public async signIn(): Promise<GoogleLoginResponseOnline> {
        const res = await SocialLogin.login({provider: 'google', options: GoogleAuthService.GoogleLoginOptions});
        if(res.result.responseType === 'offline') {
            throw new Error("Failed to connect, Google provider could not be reached");
        }
        return res.result;
    }

    public async getOAuthToken(): Promise<string> {
        const response = await SocialLogin.getAuthorizationCode({provider: 'google'});
        let token = response?.accessToken;

        if (!token) {
            await SocialLogin.refresh({provider: 'google', options: GoogleAuthService.GoogleLoginOptions});
            const response = await SocialLogin.getAuthorizationCode({provider: 'google'});
            token = response?.accessToken;
        }

        if (!token) {
            throw new Error("Could not access google services, please try signing in again");
        }

        return token;
    }
}
